<template>
  <NuxtLayout>
    <NuxtPage />
  </NuxtLayout>
</template>

<script setup lang="ts">
import type { SnsProvider } from '~/types/hml-type'

const { jwtCookie, hideLoginPopup, recentlyLoginSns, refreshToken } = useAuth()
const { setIsWebview, isWebview } = useWebviewBridge()
const { changeViewType, showProfilePopup } = useProfile()
const { update } = useTranslation()

const { locale, locales } = useI18n()
const runtimeConfig = useRuntimeConfig()
const extraLinks = computed(() => locales.value.map((locale: any) => {
  return {
    rel: 'alternate',
    hreflang: locale.code,
    href: `${runtimeConfig.public.appDomain}/${locale.code}`,
  }
}));

useHead({
  htmlAttrs: {
    lang: locale,
  },
  link: [
    ...extraLinks.value,
  ]
})

watch(locale, (newLocale) => {
  update(newLocale)
})

onMounted(() => {
  window.loginByToken = function (token: string, isNewUser?: boolean) {
    jwtCookie.value = token
    // 최초 가입(webview)일 때 프로필 메인뷰 즉시 노출 (webview는 reload가 없으므로)
    if (isNewUser) {
      changeViewType('main')
      showProfilePopup(0, 0)
    }
  }

  window.hideLoginPopup = function () {
    hideLoginPopup()
  }

  window.setRecentlyLoginSns = function (sns: SnsProvider) {
    recentlyLoginSns.value = sns
  }

  if (window.flutter_inappwebview) {
    window.flutter_inappwebview.callHandler('identifyWebView').then((result) => {
      setIsWebview(true)
    })
  }

  if (isWebview.value) {
    refreshToken()
  }
})
</script>
